<template>
  <div class="file-upload-container">
    <div v-if="sending" class="upload-overlay">
      <b-spinner variant="secondary"></b-spinner>
    </div>
    <div class="dropbox" :class="{'is-dragover': isDragOver}">
      <input type="file"
             multiple
             :name="uploadFieldName"
             @change="filesChange"
             @dragover="isDragOver = true"
             @dragenter="isDragOver = true"
             @dragend="isDragOver = false"
             @dragleave="isDragOver = false"
             @drop="isDragOver = false"
             :disabled="sending"
             accept="image/*"
             class="input-file">
      <p class="text-sm px-3 m-0 d-flex flex-column align-items-center">
        <b-icon icon="box-arrow-in-down" class="text-xl"></b-icon>
        <span class="mt-2">{{$t('forms.selectDropFilesToUpload')}}</span>
        <span class="text-xs text-light-grey font-italic">(.jpg, .png, max 5 MB)</span>
      </p>
    </div>
    <div v-if="error" class="error my-2">{{error}}</div>
    <div v-if="filesToUpload.length" class="files-preview mt-3">
      <div v-for="(item, i) in filesToUpload" :key="i"
           class="files-preview--item"
           :class="{'has-errors': item.errors.length}">
        <div class="files-preview--item__content">
          <div>
            <img :src="getFilePreviewUrl(item.file)"/>
            <p class="text-xs">{{item.file.name}}</p>
          </div>
          <b-icon @click="!sending ? removeFileToUpload(i) : false"
                  icon="x-circle-fill"
                  class="ml-2"></b-icon>
        </div>
        <div v-if="item.errors.length" class="mt-2">
          <div v-for="error in item.errors" :key="error" class="error text-xs">
            <b-icon icon="exclamation-circle-fill" class="mr-1"></b-icon>
            {{error}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UploadService from '../services/upload.service';

const uploadService = new UploadService();

export default {
  props: {
    maxFilesToUpload: Number,
    acceptedMimeTypes: Array,
    sending: Boolean,
  },
  data() {
    return {
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: 'files',
      filesToUpload: [],
      isDragOver: false,
      error: '',
    };
  },
  methods: {
    filesChange(event) {
      this.error = '';
      const { files } = event.target;
      files.forEach((file) => {
        const errors = [];
        if (!uploadService.isMimeTypeValid(file, this.acceptedMimeTypes)) errors.push(this.$t('forms.fileTypeNotValid'));
        if (!uploadService.isFileSizeValid(file)) errors.push(this.$t('forms.fileSizeNotValid'));
        if (this.filesToUpload.length >= this.maxFilesToUpload) {
          this.error = this.$t('forms.youCantAddMoreImages', { amount: this.maxFilesToUpload });
        } else {
          const fileToUpload = { file, errors };
          this.filesToUpload.push(fileToUpload);
        }
      });
      this.$emit('filesToUpload', this.filesToUpload);
    },
    getFilePreviewUrl(file) {
      return URL.createObjectURL(file);
    },
    removeFileToUpload(index) {
      const updatedFiles = this.filesToUpload.filter((item, i) => i !== index);
      this.filesToUpload = updatedFiles;
      this.$emit('filesToUpload', this.filesToUpload);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
.file-upload-container {
  position: relative;
  .upload-overlay {
    position: absolute;
    top: 0; left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    background: rgba(255, 255, 255, .5);
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.dropbox {
  outline: 2px dashed grey;
  outline-offset: -10px;
  background: white;
  color: dimgray;
  padding: 10px 10px;
  min-height: 150px;
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  transition: all .3s ease-in-out;
}

.input-file {
  opacity: 0;
  width: 100%;
  height: 150px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover,
.dropbox.is-dragover {
  background: lighten($primary, 70);
}

.dropbox.is-dragover {
  outline-offset: -20px;
}

.dropbox p {
  text-align: center;
}
.files-preview {
  &--item {
    background: #dbdbdb;
    padding: 5px 15px 5px 5px;
    border-radius: 5px;
    margin-bottom: 5px;
    &.has-errors {
      background: #f3bcbc;
    }
    &__content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      > div {
        display: flex;
        align-items: center;
        p {
          word-break: break-word;
        }
      }
      svg {
        color: $tertiary;
        cursor: pointer;
      }
      img {
        max-width: 80px;
        margin-right: 15px;
      }
    }
    p {
      margin-bottom: 0;
    }
  }
}
</style>
